/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
import React, { useState } from 'react';
import axios from 'axios';
import { Backdrop, CircularProgress, IconButton, InputAdornment } from '@mui/material';
import { Grid, Typography } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import '../../styles/sign-up.scss';
import { signup_background, veolia_header } from '../../shared/assets/images';
import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { decrypt_data } from '../../shared/utils';
import { VerifyEmail } from '../../shared/api/url-helper';

const ResetPassword = () => {

  const emailRegex = /[a-zA-Z0-9]+@[a-zA-Z]+\.[a-zA-Z]{2,3}/;  // eslint-disable-next-line
  // const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]).{8,}$/;
  // eslint-disable-next-line
  const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]{8,}$/;
  const [loading, setLoading] = useState(false);
  const [emailValidate, setEmailValidate] = useState(false);
  const [passwordValidate, setPasswordValidate] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [showCurrPassword, setShowCurrPassword] = useState(true);

  // const env_xApiKey = process.env.REACT_APP_X_API_KEY;
  // const xApiKey = decrypt_data(env_xApiKey);

  const [authData, setAuthData] = useState({
    email: '',
    curr_pwd: '',
    new_pwd: '',
    r_new_pwd: '',
  });
  const { email, curr_pwd, new_pwd, r_new_pwd, } = authData;
  // notification state management
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [passwordMatchError, setPasswordMatchError] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleToggleCurrPasswordVisibility = () => {
    setShowCurrPassword(!showCurrPassword);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAuthData({
      ...authData,
      [name]: value,
    });

    if (name === 'email') {
      if (!emailRegex.test(value)) {
        setEmailValidate(false);
        document.querySelector(`[name="${name}"]`).classList.add('error-input');
      } else {
        setEmailValidate(true);
        document.querySelector(`[name="${name}"]`).classList.remove('error-input');
      }
    } else if (name === 'new_pwd') {
      if (!passwordRegex.test(value)) {
        setPasswordValidate(false);
        document.querySelector(`[name="${name}"]`).classList.add('error-input');
      } else {
        setPasswordValidate(true);
        document.querySelector(`[name="${name}"]`).classList.remove('error-input');
      }
    } else if (name === 'r_new_pwd') {
      if (!passwordRegex.test(value)) {
        setPasswordValidate(false);
        document.querySelector(`[name="${name}"]`).classList.add('error-input');
      } else {
        setPasswordValidate(true);
        document.querySelector(`[name="${name}"]`).classList.remove('error-input');
      }
      setPasswordMatchError(new_pwd !== value); // Check on every keystroke
    }
  };
  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      type
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    let hasError = false;

    const validate_data = ['email', 'curr_pwd', 'new_pwd', 'r_new_pwd'];
    validate_data.forEach((ele) => {
      if (!authData[ele] || authData[ele].trim() === '') {
        if (document.querySelector(`[name="${ele}"]`)) {
          hasError = true;
          document.querySelector(`[name="${ele}"]`).classList.add('error-input');
        }
      } else {
        document.querySelector(`[name="${ele}"]`).classList.remove('error-input');
      }

      if (ele === 'email' && authData[ele] !== '') {
        if (!emailRegex.test(authData[ele])) {
          hasError = true;
          document.querySelector(`[name="${ele}"]`).classList.add('error-input');
        }
      }

      if ((ele === 'new_pwd' || ele === 'r_new_pwd') && authData[ele] !== '') {
        if (!passwordRegex.test(authData[ele])) {
          hasError = true;
          document.querySelector(`[name="${ele}"]`).classList.add('error-input');
        }
      }
    });

    if (new_pwd !== r_new_pwd) {
      hasError = true;
      setPasswordMatchError(true);
      document.querySelector('[name="r_new_pwd"]').classList.add('error-input');
    } else {
      setPasswordMatchError(false);
      if (r_new_pwd) {
        document.querySelector('[name="r_new_pwd"]').classList.remove('error-input');
      }
    }

    if (hasError) {
      setLoading(false);
      return;
    }
    const payload = {
      'email': email,
      'current_password': curr_pwd,
      'new_password': r_new_pwd
    };

    try {
      // await axios({
      //   method: 'post',
      //   url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/verifyEmail',
      //   headers: {
      //     'x-api-key': process.env.REACT_APP_X_API_KEY
      //   },
      //   data: payload
      // });
      await VerifyEmail(payload)
        .then(async () => {
          openModelPopUp('Password reset successfully', 'Success!', 'success');
        }).catch((error) => {
          openModelPopUp('Password reset failed. Verify current password and retry.', 'Error', 'error');
          console.error('Error posting data:', error);
        });
    } catch (error) {
      openModelPopUp('Password reset failed. Verify current password and retry.', 'Error', 'error');
      console.error('Error posting data:', error);
    }

    setLoading(false);
  };

  return (
    <div>
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        style={{
          background: '#d9dbde5c',
        }}>
        <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
      </Backdrop>
      <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
      <img src={signup_background} style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', objectFit: 'cover' }} />
      <img className='h-100' align="left" src={veolia_header} style={{ marginLeft: '48px', height: '40px', marginTop: '24px', position: 'fixed', zIndex: 1 }} />
      <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 1, right: 0, margin: 'auto', width: '450px', padding: '30px 0' }}>
        <div className='sign-up-mainpage'>
          <div className='sign-up-outer' style={{ alignItems: 'center' }}>
            <form onSubmit={handleSubmit}>
              <Grid item xs={8} className="rufusReg f14 mx-100 ">
                <p className='text-label-signup XL_heading' style={{ marginBottom: '8px' }}>Reset Password</p>
                <p className='text-label-signup S_Regular' style={{ marginBottom: '8px' }}>Please fill all the details</p>
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <p className='text-label-signup S_Regular '>Email<span style={{ color: 'red' }}>*</span></p>
                <input
                  className={`input-border input-sineup ${emailValidate ? 'input-space' : ''}`}
                  id="outlined-basic_email"
                  name="email"
                  type="email"
                  onChange={handleChange}
                  value={email}
                />
              </Grid>

              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <p className='text-label-signup S_Regular'>Current Password <span style={{ color: 'red' }}>*</span></p>
                <div style={{ position: 'relative' }}>
                  <input
                    className='input-border input-sineup'
                    id="outlined-basic_curr_pwd"
                    name="curr_pwd"
                    // type="text"
                    type={showCurrPassword ? 'password' : 'text'}
                    onChange={handleChange}
                    value={curr_pwd}
                  />
                  <InputAdornment position="end" style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer'
                  }}>
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleToggleCurrPasswordVisibility}
                      edge="end"
                    >
                      {showCurrPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                </div>
              </Grid>

              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <p className='text-label-signup S_Regular'>New Password<span style={{ color: 'red' }}>*</span></p>
                <div style={{ position: 'relative' }}>
                  <input
                    className={`input-border input-sineup ${passwordValidate ? 'input-space' : ''}`}
                    id="outlined-basic_new_pwd"
                    name="new_pwd"
                    // type="text"
                    type={showPassword ? 'password' : 'text'}
                    onChange={handleChange}
                    value={new_pwd}
                  />
                  <InputAdornment position="end" style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer'
                  }}>
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleTogglePasswordVisibility}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                </div>
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <p className='text-label-signup S_Regular'>Re-Enter New Password<span style={{ color: 'red' }}>*</span></p>
                <input
                  className={`input-border input-sineup ${passwordMatchError ? 'input-space' : ''}`}
                  id="outlined-basic_r_new_pwd"
                  name="r_new_pwd"
                  type="password"
                  onChange={handleChange}
                  value={r_new_pwd}
                />
                {passwordMatchError && (
                  <p style={{ color: 'red', fontSize: '12px' }}>Passwords do not match.</p>
                )}
              </Grid>

              {/* <Grid item style={{ marginTop: '20px', textAlign: 'center' }}>
                <p className="sansW4SeLig S_Regular ntregisterYet">
                  Password must be at least 8 characters long and contain 1 uppercase letter & 1 special character.
                </p>
              </Grid> */}

              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15" style={{ marginTop: '20px', textAlign: 'center' }}>
                <div className="remember sansW4SeLig">
                  Password must be at least 8 characters long and contain 1 uppercase letter & 1 special character.
                </div>

              </Grid>

              <Grid item style={{ marginTop: '25px', textAlign: 'center' }}>
                <input id='submit' style={{ width: 125 }} type='submit' value='Reset' className="M_Bold Primary_Default_Button submit-button  " />
              </Grid>
              <Grid item style={{ marginTop: '20px', textAlign: 'center' }}>
                <p className="sansW4SeLig S_Regular ntregisterYet">Already Signed Up ?
                  <a href="/sign-in" className="ntregister sansW6SeBld M_Regular">Login</a></p>
              </Grid>
              <Grid item style={{ marginTop: '10px' }} >
                <Typography
                  variant="body2"
                  align="center"
                  className="footerLogin S_Regular forground-text-secondary-WithoutHover">
                  powered by @Veolia
                </Typography>
              </Grid>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;
